module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.1bf71be.ttf";